module.exports = __webpack_public_path__ + "static/img/img_19.eed35d7d.png";